<div class="container-fluid">
  <div class="row d-flex flex-column">
    <h2 class="left-menu-header location-tags-header" matTooltip="List of all my tags">
      My tags
    </h2>
    <div cdkDropList #tagList="cdkDropList" [cdkDropListData]="globalTags" [cdkDropListConnectedTo]="availableConnectedIds">
      <ng-container *ngIf="globalTags && globalTags.length">
        <ng-container *ngFor="let tag of globalTags">
          <app-tag-item [tag]="tag" cdkDrag [cdkDragData]="{'data': tag, 'type': libraryEditItemTypes.EditTag}"
            (cdkDragStarted)="ui.handleItemlistDrag($event.source.data)" (cdkDragEnded)="ui.handleItemlistDrag(null)">
          </app-tag-item>
        </ng-container>
      </ng-container>
    </div>

    <h2 class="left-menu-header location-tags-header" matTooltip="List of the Shared tags">
      Shared tags
    </h2>
    <div cdkDropList #tagList="cdkDropList" [cdkDropListData]="sharedTags" [cdkDropListConnectedTo]="availableConnectedIds">
      <ng-container *ngIf="sharedTags && sharedTags.length">
        <ng-container *ngFor="let tag of sharedTags">
          <app-tag-item [tag]="tag" cdkDrag [cdkDragData]="{'data': tag, 'type': libraryEditItemTypes.EditTag}"
            (cdkDragStarted)="ui.handleItemlistDrag($event.source.data)" (cdkDragEnded)="ui.handleItemlistDrag(null)">
          </app-tag-item>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>